import {accountMovement} from "./af/accountMovement";
import {balanceBonus} from "./af/balanceBonus";
import {bankDeposit} from "./af/bankDeposit";
import {baseModalTitles} from "./af/baseModalTitles";
import {breadcrumbs} from "./af/breadcrumbs";
import {changePassword} from "./af/changePassword";
import {contact} from "./af/contact";
import {cookieConsent} from "./af/cookieConsent";
import {currency} from "./af/currency";
import {deleteAccount} from "./af/deleteAccount";
import {dropdownMenu} from "./af/dropdownMenu";
import {errorBoundary} from "./af/errorBoundary";
import {floatBtn} from "./af/floatBtn";
import {floatingMenu} from "./af/floatingMenu";
import {footer} from "./af/footer";
import {gameFeed} from "./af/gameFeed";
import {games} from "./af/games";
import {homeBtnMoneyHandler} from "./af/homeBtnMoneyHandler";
import {homeModalSessionInfo} from "./af/homeModalSessionInfo";
import {identity} from "./af/identity";
import {inviteFriend} from "./af/inviteFriend";
import {loginModal} from "./af/loginModal";
import {lottery} from "./af/lottery";
import {mobilePayment} from "./af/mobilePayment";
import {news} from "./af/news";
import {notificationDrawer} from "./af/notificationDrawer";
import {notifications} from "./af/notifications";
import {promoBanners} from "./af/promoBanners";
import {quiniela} from "./af/quiniela";
import {raffle} from "./af/raffle";
import {registrationForm} from "./af/registrationForm";
import {sideNavbar} from "./af/sideNavbar";
import {socialNotifications} from "./af/socialNotifications";
import {socialSelector} from "./af/socialSelector";
import {contactSupport} from "./af/support";
import {TOS} from "./af/TOS";
import {testimonials} from "./af/testimonials";
import {transactionTitles} from "./af/transactionTitles";
import {transferSteps} from "./af/transferSteps";
import {userProfile} from "./af/userProfile";
import {wallet} from "./af/wallet";
import {withdrawalSteps} from "./af/widthdrawalSteps";

const af = {
  ...contact,
  ...cookieConsent,
  ...contactSupport,
  ...bankDeposit,
  ...currency,
  ...sideNavbar,
  ...dropdownMenu,
  ...registrationForm,
  ...identity,
  ...userProfile,
  ...floatBtn,
  ...withdrawalSteps,
  ...homeBtnMoneyHandler,
  ...transferSteps,
  ...wallet,
  ...inviteFriend,
  ...changePassword,
  ...mobilePayment,
  ...accountMovement,
  ...transactionTitles,
  ...baseModalTitles,
  ...footer,
  ...notificationDrawer,
  ...notifications,
  ...deleteAccount,
  ...TOS,
  ...lottery,
  ...raffle,
  ...balanceBonus,
  ...loginModal,
  ...errorBoundary,
  ...games,
  ...gameFeed,
  ...breadcrumbs,
  ...floatingMenu,
  ...homeModalSessionInfo,
  ...socialSelector,
  ...promoBanners,
  ...socialNotifications,
  ...testimonials,
  ...news,
  noDataAvailable: "Geen data beskikbaar nie",
  loading: "Laai...",
  homeDisplaySportsTitle: "Sportweddenschappen",
  homeDisplaySportsSubtitle: "Speel in die beste ligas ter wêreld",
  homeDisplayContestChallengeTitle: "KOMPETISIE - Uitdaging van buite",
  latestWinners: "Jongste wenners",
  homeDisplayTopGamesTitle: "10 Mees gespeel!",
  homeDisplayAllBtn: "Sien alles",
  homeDisplayLoginBtn: "Teken in",
  homeDisplayRegisterBtn: "Registreer",
  homeDisplayLiveGames: "Komende wedstryde",
  homeDisplayLiveGamesSubtitle: "Wed met die beste kans",
  homeDisplayFootball: "Sokker",
  homeDisplayTennis: "Tennis",
  homeDisplayBasketball: "Basketbal",
  homeDisplayVolleyball: "Vlugbal",
  homeDisplayEventRules: "Byeenkomsreëls",
  homeDisplayModalTitle: "Promosie",
  homeDisplayModalClose: "Sluit",
  homeModalSessionInfoAtTime: "om",
  referralMessage: "Sluit aan by Randrush en geniet eksklusiewe voordele! Registreer met my verwysingskakel ",
  referralMessageSlots: "Registreer hier en ontvang 10 gratis spelinkies op slots! ",
  referralMessageSports: "Skep jou rekening en kry 'n eksklusiewe bonus om op jou gunsteling sport te wed! ",
  referralMessageBingo: "Skep jou rekening en ontvang gratis bingokaarte! ",
  referralMessageCasino: "Skep jou rekening en ontvang gratis skyfies vir die lewendige casino! ",
  selectMessageType: "Kies boodskaptipe",
  messageTypeGeneral: "Algemeen",
  messageTypeSlots: "Slots",
  messageTypeSports: "Sport",
  messageTypeBingo: "Bingo",
  messageTypeCasino: "Casino",
  messagePreview: "Boodskapvoorskou",
  copy: "Kopieer",
  share: "Deel",
  scanQR: "Skandeer QR",
  scanQRText: "Skandeer hierdie QR om 'n vriend te verwys",
  copyQR: "Kopieer QR",
  downloadQR: "Laai QR af",
  shareQR: "Deel QR",
  qrCopied: "QR-kode na die klembord gekopieer!",
  qrCopyFailed: "Kon nie die QR-kode kopieer nie. Probeer eerder aflaai.",
  recentReferrals: "Onlangse verwysings",
  referralProgram: "Verwysingsprogram",
  youReferralStatus: "Jou verwysingstatus",
  sharedYourLink: "Jy kan jou verwysingskakel deel deur dit te kopieer en te stuur of op jou sosiale media te deel",
  referralEarnings: "Verwysingsverdienste",
  referralSummary: "Verwysingopsomming",
  yourReferrals: "Jou verwysings",
  yourReferralsEarned: "Jou verwysings verdien",
  yourReferralsPendingEarned: "Jou verwysings hangende verdienste",
  yourReferralLink: "Jou skakel",
  qrCode: "QR-kode",
  joinedDate: "Aangesluit datum",
  date: "Datum",
  depositDate: "Deposito datum",
  status: "Status",
  reward: "Beloning",
  active: "Aktief",
  inactive: "Onaktief",
  noReferralsFound: "Geen onlangse verwysings gevind nie.",
  totalReferrals: "Totale verwysings",
  activeReferrals: "Aktiewe verwysings",
  hasDeposited: "Het gedeponeer",
  yes: "Ja",
  no: "Nee",
  pending: "Hangende",
  paid: "Betaal",
  recentEarnings: "Onlangse verdienste",
  noCommissionsYet: "Nog geen kommissie nie",
  commission: "kommissie",
  totalCommission: "Totale kommissie",
  forgotReferralCode: "Vergeet om verwysingskode in jou profiel by te voeg?",
  clickHere: "Klik hier",
  referralCodePlaceholder: "Voer jou verwysingskode in",
  send: "Stuur",
  sending: "Stuur...",
  referralCodeAppliedSuccess: "Verwysingskode suksesvol toegepas!",
  invalidOrInactiveReferralCode: "Die verwysingskode is ongeldig of onaktief",
  cashbackTitle: "Kontantterug totaal 13%",
  cashbackDesc: "Ontvang elke Maandag 13% van alles wat jy gespeel het. Alle speletjies!",
  cashbackActive: "Aktief",
  cashbackPayday: "Betaaldag!",
  cashbackNextMonday: "Volgende Maandag",
  cashbackBannerAria: "Kontantterug 13% promosie — Elke Maandag",
  registerPromoTag: "Registrasiepromosie",
  registerPromoTitle: "Registreer en wen gratis spelinkies",
  registerPromoDesc: "Vir elke R 40 wat jy by jou eerste deposito inbetaal, gee ons jou 'n gratis spelin.",
  registerPromoCta: "Registreer",
  registerPromoAria: "Registrasiepromosie — Gratis spelinkies by jou eerste deposito",
  mondaySpinsTag: "Elke Maandag",
  mondaySpinsTagToday: "Dit is Maandag!",
  mondaySpinsTitle: "Gratis spelinkies elke Maandag",
  mondaySpinsDesc: "Vir elke R 40 wat jy by die eerste deposito van die dag inbetaal, gee ons jou 'n gratis spelin.",
  mondaySpinsNextMonday: "Volgende Maandag",
  mondaySpinsDeposit: "Deponeer",
  mondaySpinsAria: "Maandagpromosie — Gratis spelinkies elke Maandag",
  dailySpinsTitle: "Spin en wen dubbel",
  dailySpinsDesc:
    "Van Maandag tot Maandag behalwe Donderdag, vir elke spelin wat jy tussen 8 en 9 nm maak, gee ons jou 'n vriendelike spelin.",
  dailySpinsTag: "Elke dag behalwe Donderdae",
  dailySpinsNextActive: "Volgende aktief oor",
  homeHeroTagPromo: "Promo",
  homeHeroTagNew: "Nuwe skuif",
  homeHeroTagDrop: "Drop",
  homeHeroTagRace: "Wedloop",
  homeHeroTagTournament: "Toernooi",
  miniGamesTitle: "Mini-speletjies",
  miniGamesViewAll: "Sien alles",
  miniGamesCarouselAria: "Casino mini-speletjies karrousel",
  categoryUnavailableTag: "Binnekort beskikbaar",
  categoryUnavailableTitle: "Ons verbeter hierdie kategorie",
  categoryUnavailableTitleNamed: "Ons verbeter die {{category}}-ervaring",
  categoryUnavailableMessage:
    "Hierdie afdeling sal binnekort weer beskikbaar wees. Ons werk aan 'n beter ervaring vir jou. Dankie vir jou geduld.",
  categoryUnavailableBack: "Terug na die tuisblad",
  categoryUnavailableExplore: "Verken ander speletjies",
  ...quiniela,
};

export default af;
